import { useEffect, useRef, useState } from 'react'

const useElementWidth = (): [
  React.MutableRefObject<HTMLDivElement | null>,
  number
] => {
  const elementRef = useRef<HTMLDivElement | null>(null)
  const [width, setWidth] = useState<number>(0)

  useEffect(() => {
    const handleResize = () => {
      if (elementRef.current) {
        setWidth(elementRef.current.offsetWidth)
      }
    }

    // Set the initial width
    handleResize()

    // Add event listener for window resize
    window.addEventListener('resize', handleResize)

    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return [elementRef, width]
}

export default useElementWidth
